import React from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "@cloudpremise/portal_core/src/themes/mui/components/MDBox";
import MDTypography from "@cloudpremise/portal_core/src/themes/mui/components/MDTypography";
import MDButton from "@cloudpremise/portal_core/src/themes/mui/components/MDButton";

import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import TextSnippetOutlinedIcon from '@mui/icons-material/TextSnippetOutlined';
import SurfingOutlinedIcon from '@mui/icons-material/SurfingOutlined';

const Eos = () => {
    return (
        <Grid container spacing={3} className="hermes-container">
            <Grid item xs={12} md={6} lg={6}>
                <Card>
                    <MDBox p={2}>
                        <MDTypography component="h6" variant="button" fontWeight="bold" color="dark" mb={1}>
                            <VisibilityOutlinedIcon /> Review Staging
                        </MDTypography>
                        <MDTypography component="p" variant="button" fontWeight="light" color="dark" mb={2}>
                            Review the staging environment and test your updates before deployment.
                        </MDTypography>
                        <MDButton variant="outlined" color="light">
                            Open Staging
                        </MDButton>
                    </MDBox>
                </Card>
            </Grid>
            <Grid item xs={12} md={6} lg={6}>
                <Card>
                    <MDBox p={2}>
                        <MDTypography component="h6" variant="button" fontWeight="bold" color="dark" mb={1}>
                            <CloudUploadOutlinedIcon /> Update Production
                        </MDTypography>
                        <MDTypography component="p" variant="button" fontWeight="light" color="dark" mb={2}>
                            Deploy to production manually or enable auto-deploy (premium).
                        </MDTypography>
                        <MDButton variant="contained" color="dark">
                            Deploy Now
                        </MDButton>
                    </MDBox>
                </Card>
            </Grid>
            <Grid item xs={12} md={6} lg={6}>
                <Card>
                    <MDBox p={2}>
                        <MDTypography component="h6" variant="button" fontWeight="bold" color="dark" mb={1}>
                            <TextSnippetOutlinedIcon /> System Logs
                        </MDTypography>
                        <MDTypography component="p" variant="button" fontWeight="light" color="dark" mb={2}>
                            Review historical logs, errors and system events across environments.
                        </MDTypography>
                        <MDButton variant="outlined" color="light">
                            View Logs
                        </MDButton>
                    </MDBox>
                </Card>
            </Grid>
            <Grid item xs={12} md={6} lg={6}>
                <Card>
                    <MDBox p={2}>
                        <MDTypography component="h6" variant="button" fontWeight="bold" color="dark" mb={1}>
                            <SurfingOutlinedIcon /> Surf Mode
                        </MDTypography>
                        <MDTypography component="p" variant="button" fontWeight="light" color="dark" mb={2}>
                            Enable AI-managed deployments. Athena thinks. Hephaestus designs. Forge builds. Eos deploys. Chronos monitors. Proteus endures.
                        </MDTypography>
                        <MDButton variant="outlined" color="light">
                            Let’s Go!
                        </MDButton>
                    </MDBox>
                </Card>
            </Grid>
        </Grid>
    );
};

export default Eos;